import MyScoutdeck from './(components)/my-scoutdeck'
import QuickSearch from './(components)/quick-search'
import ScoutdeckDatabase from './(components)/scoutdeck-database'

const DashboardPage = () => {
  return (
    <div className='p-4 space-y-4'>
      <header>
        <h1 className='text-3xl font-bold'>Dashboard</h1>
      </header>
      <div className='grid grid-cols-2 gap-4 md:gap-8'>
        <div className='flex flex-col gap-4 md:gap-8'>
          <QuickSearch />
        </div>
        <div className='flex flex-col gap-4 md:gap-8'>
          <ScoutdeckDatabase />
          <MyScoutdeck />
        </div>
      </div>
    </div>
  )
}

export default DashboardPage